@if (entry.base?.display) {
  <!-- Houses dynamically updated stringified data-->
  <form [formGroup]="form" [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath"></form>
  <!-- Houses component specific, parsed data -->
  <h3 class="header big-space">NOTIFICATION AND AUTHORIZATION</h3>
  <hr/>
  <p><span>{{nameNodeValue}}</span></p>
  <div [formGroup]="consumerNpnForm">
    <p>Date: {{signOrSubmissionDate}}</p>
    <!-- Working with Producer? radio -->
    <div class="radio-container">
      <mat-label>Are you working with a producer to fill out this application?<span class='required-asterisk'>*</span></mat-label>
      <mat-radio-group formControlName="workingWithProducerIndicator">
        <mat-radio-button value="true">Yes</mat-radio-button>
        <mat-radio-button value="false">No</mat-radio-button>
      </mat-radio-group>
      @if (consumerNpnFormControls.workingWithProducerIndicator?.errors?.required && consumerNpnFormControls.isPrescribedMeds.touched) {
        <mat-error>This field is required</mat-error>
      }
    </div>
    <div class="npn-form" [hidden]="!consumerNpnFormControls.workingWithProducerIndicator.value || consumerNpnFormControls.workingWithProducerIndicator.value == 'false'">
      <p>A Producer assisted me in apply for this plan. As part of this process, the Producer answerd my questions and advised me on the plan's features, including the plan's deductible levels. I understand that this Producer will receive certain personally identifiable information about me and my dependents. The Producer Name and National Producer Number (NPN) of this Producer who assisted me are:</p>
      <!-- producerFirstName -->
      <mat-form-field appearance="outline">
        <input type="text" matInput formControlName="producerFirstName" placeholder="Producer First Name"/>
        @if (consumerNpnFormControls.producerFirstName?.errors?.required) {
          <mat-error>This field is required.</mat-error>
        }
      </mat-form-field>
      <!-- producerLastName -->
      <mat-form-field appearance="outline">
        <input type="text" matInput formControlName="producerLastName" placeholder="Producer Last Name"/>
        @if (consumerNpnFormControls.producerLastName?.errors?.required) {
          <mat-error>This field is required.</mat-error>
        }
      </mat-form-field>
      <!-- npn -->
      <mat-form-field appearance="outline">
        <input type="text" matInput formControlName="npn" placeholder="NPN"/>
        @if (consumerNpnFormControls.npn?.errors?.required) {
          <mat-error>This field is required.</mat-error>
        }
      </mat-form-field>
      <!-- verifyNpn -->
      <mat-form-field appearance="outline">
        <input type="text" matInput formControlName="verifyNpn" placeholder="Re-Enter NPN"/>
        @if (consumerNpnFormControls.verifyNpn?.errors?.required) {
          <mat-error>This field is required.</mat-error>
        }
        @if (consumerNpnFormControls.verifyNpn?.errors?.npnVerificationFailed) {
          <mat-error>Enter NPN value as it appears in the first NPN box.</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
}


